import React, { useEffect, useState } from "react";
import { GroupAdministrationView } from "../../views";
import { DomainService, LocalStorageService,PermissionService } from "../../../services/index";
import { ConfigurationDomainValidator } from "../../../validators";
import { useHistory } from "react-router-dom";
import { ModalUtil } from "../../pures";
import { useTranslation } from "react-i18next";

const url = process.env.REACT_APP_ETICKET_API;
const localStorageService = new LocalStorageService();
let token = localStorageService.getLocalStorageItem("token")
let user = localStorageService.getLocalStorageItem("user")
if (token) token = token.idToken
const permissionService = new PermissionService(url);
const modalUtil = new ModalUtil()

const GroupAdministrationAction = () => {
  const history = useHistory()
  const { t } = useTranslation();
  const { t: tCommon } = useTranslation('common');

  const [loading, setLoading] = useState(true)

  const [permissions, setPermissions] = useState([])
  const [users, setUsers] = useState([])
  const [usersByPermission, setUsersByPermission] = useState([])
  const [selectedPermission, setSelectedPermission] = useState(null)
  const [action, setAction] = useState(null)
  const [showDialogDeletePermission, setShowDialogDeletePermission] = useState(false)
  const [loadingUsers, setLoadingUsers] = useState(false)

  const toggleDialogDeletePermission = (show) => {
    setShowDialogDeletePermission(show)
  }

  const getUsersByClientId = async () => {
    try {
      setLoading(true)
      setAction(null)
      const users = await permissionService.getUserByClientId(user?.userMetaData?.userA3Cloud?.clientId, token);
      setUsers(users.data);
      setLoading(false)
    } catch (err) {
      console.log(err,"el error")
      modalUtil.showModal('error', 'Error cargando usuarios', 'Error getUsersByClientId', () => history.push('/'))
    }
  }

    const getUsersByPermission = async (id) => {
    try {
      setLoadingUsers(true)
      const users = await permissionService.getUsersByPermission(id, token);
      setUsersByPermission(users);
      setLoadingUsers(false)
    } catch (err) {
      console.log(err,"el error")
      setLoadingUsers(false)
      modalUtil.showModal('error', 'Error cargando usuarios', 'Error getUsersByClientId', () => history.push('/'))
    }
  }

  const getPermissions = async () => {
    try {
      setLoading(true)
      setAction(null)
      const permissions = await permissionService.getAllPermissions(user?.userMetaData?.userA3Cloud?.clientId, token);
      setPermissions(permissions);
      setLoading(false)
    } catch (err) {
      console.log(err,"el error")
      modalUtil.showModal('error', 'Error cargando permisos', 'Error getPermissions', () => history.push('/'))
    }
  }

  const deletePermission = async (permissionToDelete) => {
    try {
      setShowDialogDeletePermission(false)
      modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))
      
      const permissionId = permissionToDelete?.id || selectedPermission?.id;
      
      if (!permissionId) {
        throw new Error('No se pudo obtener el ID del permiso a eliminar')
      }
      
      let response = await permissionService.deletePermission(
        permissionId,
        token
      );

      if (response.statusCode === 200) {
        await modalUtil.showModal('success', t("configuration.permissions.action.deletePermissionSuccess"), t("modal.pure.title.success"))
        getPermissions()
        setSelectedPermission(null)
        return;
      } else {
        throw new Error(t("configuration.permissions.action.deletePermissionError"))
      }
    } catch (error) {
      modalUtil.showModal('error', error.message, t("modal.pure.title.error"))
    }
  };

  const createPermission = async (data) => {
    try {
      let { name, description } = data
      let key = name.replaceAll(' ', '_').toUpperCase() 
      modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))
      const response = await permissionService.createPermission("b2159583-399f-44a0-8128-2918f56ddcf6", user.userMetaData.userA3Cloud.clientId, name, description, key, token);
      if (response.statusCode === 200) {
        await modalUtil.showModal('success', t("configuration.permissions.action.createPermissionSuccess"), t("modal.pure.title.success"))
        getPermissions()
        return
      } else if (response.statusCode === -2) {
        modalUtil.showModal('error', t("configuration.permissions.action.permissionExists"), t("modal.pure.title.error"))
      } else {
        throw new Error(t("configuration.permissions.action.general.error"))
      }
    } catch (error) {
      modalUtil.showModal('error', error.message, t("modal.pure.title.error"))
    }
  }

  const editPermission = async (data) => {
    const { clientId, description, name, id, usersToAdd, usersToRemove, token } = data
    try {

      modalUtil.showModal('loading', t("modal.pure.loading.title"), t("modal.pure.loading.message"))

      const response = await permissionService.updatePermission(clientId, description, id, name, usersToAdd, usersToRemove, token);

      if (response.statusCode === 200) {
        await modalUtil.showModal('success', t("configuration.permissions.action.updatePermissionSuccess"), t("modal.pure.title.success"))
        setSelectedPermission(null)
        getPermissions()
        return;
      } else if (response.statusCode === -2) {
        modalUtil.showModal('error', t("configuration.permissions.action.updatePermissionError"), t("modal.pure.title.error"))
      } else if (response.statusCode === -3) {
        modalUtil.showModal('error', t("configuration.permissions.action.permissionSignerUpdateError"), t("modal.pure.title.error"))
      } else {
        throw new Error(t("configuration.permissions.action.general.error.edit"))
      }
    } catch (error) {
      modalUtil.showModal('error', error.message, t("modal.pure.title.error"))
    }
  }

  useEffect(() => {
    getPermissions();
    getUsersByClientId();
  }, [])

  return (
    <GroupAdministrationView
      // Permissions
      permissions={permissions}
      setPermissions={setPermissions}
      users={users}
      usersByPermission={usersByPermission}
      selectedPermission={selectedPermission}
      setSelectedPermission={setSelectedPermission}
      showDialogDeletePermission={showDialogDeletePermission}
      toggleDialogDeletePermission={toggleDialogDeletePermission}
      deletePermission={deletePermission}
      createPermission={createPermission}
      editPermission={editPermission}
      setAction={setAction}
      action={action}
      getUsersByPermission={getUsersByPermission}
      loading={loading}
      loadingUsers={loadingUsers}
    />
  )
}


export { GroupAdministrationAction as default };
